import { CreativeSchedule } from './CreativeSchedule'

export class TemporaryCampaignBudgetModel {
  constructor(data) {
    const {
      id,
      campaignId,
      insertionOrderBudgetRequestId,
      budget,
      startTime,
      endTime,
      pacingType,
      dailyLimitBudget,
      evenPacePercentage,
      creativeSchedules,
    } = data
    this.id = id
    this.campaignId = campaignId
    this.insertionOrderBudgetRequestId = insertionOrderBudgetRequestId
    this.budget = budget
    this.startTime = startTime
    this.endTime = endTime
    this.pacingType = pacingType
    this.dailyLimitBudget = dailyLimitBudget
    this.evenPacePercentage = evenPacePercentage
    this.creativeSchedules = creativeSchedules.map(CreativeSchedule.assign)
  }

  static assign(data) {
    return new TemporaryCampaignBudgetModel(data)
  }
}
